import { useCallback, useEffect, useRef, useState } from 'react';

import { getSignedURL } from 'api/endpoints/upload';
import { formatTime, handleVideoSurvey } from 'utils/helper';

const PlayVideo = require('assets/resources/PlayVideo.svg').default;
const VideoFile = require('assets/resources/VideoFile.svg').default;

const Video = ({ videoUrl, sourceBucket, sourceBlob, categoryName }) => {
  const [duration, setDuration] = useState(0);
  const [sizeVideo, setSizeVideo] = useState({ width: 0, height: 0 });
  const [src, setSrc] = useState('');
  const videoRef = useRef(null);

  const setUpVideo = () => {
    if (videoRef.current) {
      setDuration(Math.floor(videoRef.current.duration));
    }
  };

  const handleGetWidthAndHeightVideo = useCallback(() => {
    if (videoRef.current) {
      const width = videoRef.current.offsetWidth;
      const height = videoRef.current.offsetHeight;
      setSizeVideo({ width, height });
    }
  }, [videoRef]);

  useEffect(() => {
    handleGetWidthAndHeightVideo();
  }, [handleGetWidthAndHeightVideo]);

  const handleLoadImage = useCallback(async () => {
    if (videoUrl) {
      setSrc(videoUrl);
    } else {
      const signedURL = await getSignedURL({ blob_name: sourceBlob, bucket_name: sourceBucket });
      const { signed_url, etag } = signedURL.data;
      const videos = await handleVideoSurvey([{ signed_url, etag }]);
      if (videos.length > 0) {
        videos[0]?.url_preview && setSrc(videos[0].url_preview);
      }
    }
  }, [sourceBlob, sourceBucket, videoUrl]);

  useEffect(() => {
    handleLoadImage();
  }, [handleLoadImage]);

  return (
    <>
      <div className="flex flex-col gap-2 py-2 px-4">
        <div className="flex items-center gap-3 px-2">
          <img src={VideoFile} alt="video" />
          <p className="font-bold">{categoryName}</p>
        </div>
        <div className="relative rounded overflow-hidden w-full h-[338px]">
          <div className="w-full h-full flex items-center justify-center">
            <video
              onLoadedMetadata={setUpVideo}
              onLoadedData={handleGetWidthAndHeightVideo}
              ref={videoRef}
              src={src}
              className="max-w-full max-h-full object-center"
            />
          </div>
          <div
            className="absolute font-bold text-white text-sm"
            style={{ left: `calc(((100% - ${sizeVideo.width}px) / 2) + 11px)`, bottom: `calc(((100% - ${sizeVideo.height}px) / 2) + 7.5px)` }}
          >
            <p>{formatTime(Math.floor(duration))}</p>
          </div>
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
            <img src={PlayVideo} alt="play video" className="cursor-pointer" />
          </div>
        </div>
      </div>
    </>
  );
};

export default Video;
